module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/modules/_library.js
// module id = 54
// module chunks = 92